module.exports = __webpack_public_path__ + "img/taili13.7e5f69e5.jpg";